import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import _merge from 'lodash/merge';
import { DEFAULT_LOCALE } from './en_US';
// TODO: will be changed to `undefined` when MeetWrapper is implemented.
export var localeContext = createContext(DEFAULT_LOCALE);
localeContext.displayName = 'LocaleContext';
export var LocaleConsumer = localeContext.Consumer;
export var useLocale = function () { return useContext(localeContext); };
export var LocaleProvider = function (props) {
    var Provider = localeContext.Provider;
    var outerLocale = useLocale();
    var value = useMemo(function () { return _merge({}, DEFAULT_LOCALE, outerLocale, props.locale); }, [props.locale, outerLocale]);
    return _jsx(Provider, __assign({ value: value }, { children: props.children }), void 0);
};
LocaleProvider.displayName = 'LocaleProvider';
